<template>
  <div>
    <div class="quit-operate-box cleaefix">
      <div class="quit-l">
        <a-button
          :disabled="!selectedRowKeys.length"
          @click="showDialog"
        >
          {{ $t('message["500"]') }}
        </a-button>
        <span>{{ quitName.truename }}</span>
        {{ activeLabel }} <em>{{ quitListDatas.data ? quitListDatas.data.count : 0 }}</em>
        {{ infoTip[0] }} {{ selectedRowKeys.length }}/{{ quitListDatas.data ? quitListDatas.data.count : 0 }} {{ infoTip[1] }}
      </div>
      <div
        v-if="$route.query.scope !== 'clue'"
        class="quit-r"
      >
        <a-button
          class="filter-icon"
          :class="{'fs-blue': isFilter }"
          @click="openFilter"
        >
          <i class="iconfont iconicon-test20" />
          {{ $t('message["960"]') }}
        </a-button>
      </div>
    </div>
    <template v-if="datasReady">
      <a-table
        v-if="datasReady && columnsT.length"
        :columns="columnsT"
        :data-source="dataList"
        :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :pagination="false"
        :loading="!datasReady"
        class="table-list"
        :class="{'clue-quit-table': $route.query.scope === 'clue'}"
      >
        <span
          slot="code"
          slot-scope="code"
        >{{ code.code || code }}</span>
        <div
          slot="clue_status"
          slot-scope="text, record"
          class="clue-status-td"
        >
          <span
            class="status_tag"
            :class="record.status ? `status${record.status}`: childStatus(text.status_title)"
          >{{ text }}</span>
          <span
            v-if="record.status === -3"
            class="question-follow"
          > [疑似无效]</span>
        </div>
        <span
          slot="base_info_info_level"
          slot-scope="base_info_info_level"
        >
          <a-rate
            v-if="base_info_info_level.type !== 1"
            :default-value="base_info_info_level.info_level.fieldvalue"
            :count="base_info_info_level.level || 5"
            disabled
          />
          <span v-else>{{ info_level2(base_info_info_level.info_level.fieldvalue) || '--' }}</span>
        </span>
        <span
          slot="follow_date"
          slot-scope="text"
          class="clue-follow"
          :class="{'status-overtime': text.status*1 ===3}"
        >
          {{ text.time }}
        </span>
        <span
          slot="contact_info_company_name"
          slot-scope="contact_info_company_name"
        >
          <company-tooltip :text="contact_info_company_name" />
        </span>
        <span
          slot="base_info_info_type"
          slot-scope="text"
        >
          <template v-if="text.info_type && text.info_type.fieldvalue">

            {{ text.info_type.fieldvalue }}
          </template>
          <a-tag v-if="text.info_sign && text.info_sign.fieldvalue">{{ text.info_sign.fieldvalue }}</a-tag>
        </span>
        <span
          slot="contact_info"
          slot-scope="text"
        >
          <contact-tooltip :text="text" />
        </span>
        <span
          slot="last_followup_time"
          slot-scope="text"
        >
          <followup-tooltip :text="text" />
        </span>
        <div
          slot="next_followup_time"
          slot-scope="next_followup_time"
        >
          {{ next_followup_time.next_followup_time || '--' }} {{ next_followup_time.is_delay ? $t('message["103"]') : '' }}
        </div>
      </a-table>
      <pagination
        v-if="dataList.length && columnsT.length"
        ref="pagination"
        :pagination="pagination"
        @change="handlePage"
      />
    </template>
    <div
      v-else
      class="loading"
    >
      <a-spin class="loading" />
    </div>
    <quit-dialog
      ref="quitDialog"
      :inquryid="selectedRowKeys"
    />
    <filter-modal
      :visible.sync="showFilterModal"
      class="filter-modal"
      @handleFilterData="handleFilterData"
    />
    <filter-tip-dialog ref="filterTipDialog" />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from '@/components/pc/Pagination'
import QuitDialog from '@/components/pc/quit/QuitDialog'
import FilterModal from '@/components/pc/quit/filter/Filter'
import ContactTooltip from './tooltip/ContactTooltip'
import CompanyTooltip from './tooltip/CompanyTooptip'
import FollowupTooltip from './tooltip/FollowupTooptip'
import FilterTipDialog from '@/components/pc/quit/FilterTipDialog'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    Pagination,
    QuitDialog,
    FilterModal,
    ContactTooltip,
    CompanyTooltip,
    FollowupTooltip,
    FilterTipDialog
  },
  props: {
    activeLabel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedRowKeys: [],
      selected: 0,
      showFilterModal: false,
      isFilter: false,
      isSubmting: false
    }
  },
  computed: {
    ...mapState('quit', ['pagination', 'quitName', 'quitListDatas', 'filterResult', 'listShow', 'datasReady']),
    ...mapGetters('quit', ['dataList', 'columnsT']),
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    },
    filterDatas () {
      const { filterResult } = this
      let obj = {}
      filterResult.forEach(item => {
        const itemObj = {
          [item.fieldkey]: item.fieldvalue
        }
        if (item.fieldtype === 'radioinfo_type') {}
        obj = Object.assign(obj, itemObj)
        if (item.fieldtype === 'radioinfo_type') {
          const { fieldconfig = {} } = item || {}
          const { info_sign: infoSign = {} } = fieldconfig
          obj['base_info.info_sign'] = infoSign.fieldvalue
        }
      })

      return obj
    },
    infoTip () {
      return this.$t('message["1200"]').split('|')
    }
  },
  watch: {
    listShow (val) {
      if (val) {
        this.pagination.currentPage = this.currentPage
        this.pagination.pageSize = this.pageSize
        this.setListShow(false)
      }
    },
    dataList: {
      handler (to) {
        if (to) {
          this.selectedRowKeys = []
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('quit', ['quitFilterDatas', 'getPeronListsDatas']),
    ...mapMutations('quit', ['setListShow', 'setFilterResult']),
    info_level2 (val) {
      let newVal
      ['A', 'B', 'C', 'D', 'E', 'F', 'G'].forEach((item, index) => {
        if (val - 1 === index) {
          newVal = item
        }
      })
      return newVal
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      const { filterarr = [] } = this.$route.query
      this.setFilterResult(filterarr)
      if (filterarr.length) {
        this.$delete(this.$route.query, 'filterarr')
      }
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize
        }
      })
      const b = !!this.filterResult && !!this.filterResult.length
      if (b) {
        this.$route.query.filterarr = this.filterResult
      }
      this.fetchData(b)
    },
    handleFilterData (val) {
      this.fetchData(val)
      // this.$route.query.filter = this.filterDatas
      this.$route.query.filterarr = this.filterResult
      this.showFilterModal = false
    },
    async fetchData (b, params = {}) {
      params.page = this.pagination.currentPage
      params.limit = this.pagination.pageSize
      params.userid = this.$route.query.userid * 1
      params.scope = this.$route.query.scope
      if (b) {
        params.search = this.filterDatas
      }
      this.isSubmting = true
      const chain = await this.getPeronListsDatas({ isFilter: b, isClue: params.scope === 'clue' })
      chain
        .params(params)
        .onSuccess(raw => {
          this.isFilter = b
        })
        .onNetComplete(() => {
          this.isSubmting = false
        })
        .fetch()
    },
    showDialog () {
      this.$refs.quitDialog.changeVisible(true)
    },
    async openFilter () {
      if (this.$route.query.filterarr && this.$route.query.filterarr.length) {
        this.setFilterResult(this.$route.query.filterarr)
        this.showFilterModal = true
        eventBus.$emit('setItem')
      } else {
        const chain = await this.quitFilterDatas()
        chain.params({ scope: this.$route.query.scope })
          .onSuccess(raw => {
            this.showFilterModal = true
          })
          .fetch()
      }
    },
    childStatus (str) {
      let statusClass = 'status1'
      switch (str) {
        case '任务超时':
          statusClass = 'status3'
          break
        case '无效（无法联系）':
        case '无效（人工确定）':
          statusClass = 'status-1'
          break
        case '已转为信息':
          statusClass = 'status2'
          break
        case '等待中':
          statusClass = 'status4'
          break
        default:
          statusClass = 'status1'
      }
      return statusClass
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list::v-deep {
  &.clue-quit-table{
    th,td{
      padding: 12px 8px;
    }
  }
  .ant-checkbox-wrapper {
    margin: 0 !important;
  }
  td{
    word-break: break-all;
  }
  .clue-status-td{
    white-space: nowrap;
  }
  .status_tag ,.status-3 {
  position: relative;
  background: #fff;
  font-size: 12px;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  padding: 2px 6px 2px 14px;
  color:#4CA0F2;
  font-size: 12px;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 4px;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
   background: #4CA0F2
  }
}
  .status2 {
    color: #42C27E;
    &::before{
      background:#42C27E ;
    }
  }
  .status3 {
    color: #F6A953;
    &::before{
      background:#F6A953 ;
    }
  }
  .status-1, .status-2 {
    color: #999;
    &::before{
      background:#999;
    }
  }
  .status4 {
    color:#333;
    &::before{
      background:#999;
    }
  }
  .status-overtime{
    color: #F57676;
  }
}
.quit-operate-box {
  margin: 24px 0 0;
  padding-bottom: 24px;
  .quit-l em {
    font-style: normal;
    color: #42c27e;
  }
  .quit-l {
    float: left;
  }
  .quit-r {
    float: right;
    button {
      margin-right: 0;
      &.fs-blue {
        .iconfont {
          color: #5077aa;
        }
      }
      .iconfont {
        color: #d6d6d6;
      }
    }
  }
}
.ant-table-wrapper {
  padding-top: 24px;
}
em {
  font-style: normal;
}
</style>
<style lang="scss">
  .clue-follow-log-list{
    p{
      font-size: 12px;
      line-height: 20px;
    }
  }
</style>
